import { Component } from '@angular/core';
import { AccountService } from 'app/core/services/account.service';
import { SharedService } from 'app/shared/services/shared.service';
import { User } from 'app/shared/models/User';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'app';
    user: User;
    errors: string[] = [];

    constructor(
        private accountService: AccountService,
        private sharedService: SharedService
    ) {
    }

    ngOnInit() {
        //this.accountService.getUser().subscribe(
        //    user => {
        //        this.user = user;
        //        this.sharedService.changeCurrentUser(this.user);
        //        console.log("User set: " + user.email + " (app.component)");
        //    },
        //    error => this.errors = error.errorList
        //);

    }
}
